import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AppProvider, useApp } from "./contexts/AppContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BrandMarks from "./components/BrandMarks";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import WorkingInPNGPage from "./pages/WorkingInPNGPage";
import OpportunitiesPage from "./pages/OpportunitiesPage";
import ApplyHubPage from "./pages/ApplyHubPage";
import VisaRequestPage from "./pages/forms/VisaRequestPage";
import JobSeekerPage from "./pages/forms/JobSeekerPage";
import CompanySubmissionPage from "./pages/forms/CompanySubmissionPage";
import GeneralInterestPage from "./pages/forms/GeneralInterestPage";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";

function Loading() {
  return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center",
      background:"linear-gradient(135deg,#001F4D,#9E1F29)", color:"#fff", fontFamily:"'Nunito',sans-serif" }}>
      <div style={{ textAlign:"center" }}>
        <div style={{ display:"flex", justifyContent:"center", marginBottom:"1.25rem" }}>
          <BrandMarks size={64}/>
        </div>
        <div style={{ fontSize:"1rem", opacity:.8 }}>Loading Korea Papua LNG…</div>
      </div>
    </div>
  );
}

function PublicLayout() {
  const { isAdmin, handleLogout, loaded } = useApp();
  if (!loaded) return <Loading/>;
  return (
    <>
      <Navbar isAdmin={isAdmin} onLogout={handleLogout}/>
      <main><Outlet/></main>
      <Footer/>
    </>
  );
}

function AdminLayout() {
  const { isAdmin, handleLogout, loaded } = useApp();
  if (!loaded) return <Loading/>;
  if (!isAdmin) return <Navigate to="/login" replace/>;
  return (
    <>
      <Navbar isAdmin onLogout={handleLogout}/>
      <AdminDashboard onLogout={handleLogout}/>
    </>
  );
}

function LoginLayout() {
  const { isAdmin, loaded } = useApp();
  if (!loaded) return <Loading/>;
  if (isAdmin) return <Navigate to="/admin" replace/>;
  return <Outlet/>;
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Routes>
          <Route element={<PublicLayout/>}>
            <Route path="/"                element={<HomePage/>}/>
            <Route path="/about"           element={<AboutPage/>}/>
            <Route path="/working-in-png"  element={<WorkingInPNGPage/>}/>
            <Route path="/opportunities"   element={<OpportunitiesPage/>}/>
            <Route path="/apply"           element={<ApplyHubPage/>}/>
            <Route path="/apply/visa"      element={<VisaRequestPage/>}/>
            <Route path="/apply/jobs"      element={<JobSeekerPage/>}/>
            <Route path="/apply/company"   element={<CompanySubmissionPage/>}/>
            <Route path="/apply/general"   element={<GeneralInterestPage/>}/>
          </Route>
          <Route element={<LoginLayout/>}>
            <Route path="/login" element={<AdminLogin/>}/>
          </Route>
          <Route path="/admin" element={<AdminLayout/>}/>
          <Route path="*"      element={<Navigate to="/" replace/>}/>
        </Routes>
      </AppProvider>
    </BrowserRouter>
  );
}
